import { useRef, useEffect } from 'react'

export function useInterval(
  /**
   * The callback to be invoked at a regular interval.
   */
  callback: () => void,

  /**
   * Delay in miliseconds. If `null` is passed, the callback will not be invoked.
   */
  delay: null | number
): void {
  const savedCallback = useRef<() => void>(() => {})

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current?.()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }

    return () => {}
  }, [delay])
}
